export const isCSSVar = (name: string) => name.startsWith("--")
